export default __webpack_public_path__ + "static/media/Vector-blue.f2c57b91.svg";